<template>
    <v-container fluid class="pa-0">
    <v-row class="align-stretch justify-start">
      <v-col cols="12" md="4" class="pa-2 pt-0">
        <LastPlayersSearch @heightChange="lastPlayersSearchHeight=$event"></LastPlayersSearch>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0">
        <FavoritesWidget
          :userId="currentUser.id"
          v-bind:style="{'height':lastPlayersSearchHeight+'px'}"
        ></FavoritesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0">
        <CollectionsWidget v-bind:style="{'height':lastPlayersSearchHeight+'px'}"></CollectionsWidget>
      </v-col>
      <!--Hub-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <LastScoutingAnalysesWidget></LastScoutingAnalysesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <ScoutingTasksWidget></ScoutingTasksWidget>
      </v-col>
      <!--Capture-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <UploadedGamesWidget></UploadedGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <CapturePlaylistsWidget></CapturePlaylistsWidget>
      </v-col>
      <v-col cols="12" class="pa-2" v-if="userHasRole('ROLE_EVENTING_DATA')">
        <ChartsWidget
          class="elevation-2"
          :slides="['playerScoutChart']"
        ></ChartsWidget>
      </v-col>
      <v-col cols="12" class="pa-2">
        <ReportsWidget @heightChange="reportsHeight=$event" style="min-height:260px"></ReportsWidget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FavoritesWidget from "./widgets/FavoritesWidget";
import CollectionsWidget from "./widgets/CollectionsWidget";
import LastPlayersSearch from "./widgets/LastPlayersSearch";
import ReportsWidget from './widgets/ReportsWidget';
import ChartsWidget from './widgets/ChartsWidget';
import { userHasRole } from "../../utils/functions";
import LastScoutingAnalysesWidget from "./widgets/LastScoutingAnalysesWidget.vue";
import ScoutingTasksWidget from "./widgets/ScoutingTasksWidget.vue";
import UploadedGamesWidget from "./widgets/UploadedGamesWidget.vue";
import CapturePlaylistsWidget from "./widgets/CapturePlaylistsWidget.vue";

export default {
  name: "AgencyDashboard",
  props: {},
  components: {
    FavoritesWidget,
    CollectionsWidget,
    LastPlayersSearch,
    ReportsWidget,
    ChartsWidget,
    LastScoutingAnalysesWidget,
    ScoutingTasksWidget,
    UploadedGamesWidget,
    CapturePlaylistsWidget
  },
  data() {
    return {
      loading: false,
      lastPlayersSearchHeight: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {},
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/views/dashboard/AgencyDashboard.vue